import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useCurrentFullLocale } from "../../../../common/utils/locale.ts";
import A11yPanel from "../../../../common/features/a11y-panel/A11yPanel.tsx";
import { ManageAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";

export default function AssetAccessibility({
  asset,
  explore,
}: {
  asset?: ManageAsset;
  explore?: VST.Bridge.Asset;
}) {
  const brand = useBrandLoaderData();
  const locale = useCurrentFullLocale();
  const dev = import.meta.env.VITE_A11Y_PANEL_DEV === "true";
  //fallback to explore vbid if no manage data
  const vbid = asset?.vbid ?? explore?.vbid;

  return (
    <>
      {vbid && (
        <A11yPanel
          vbid={vbid}
          locale={locale}
          theme={brand.Theme.primary}
          dev={dev}
        />
      )}
    </>
  );
}
